import { Notification } from 'element-ui';

function downloadFileInBackground(url, fileName = 'downloaded-file') {
    const loadingNotification = Notification({
        message: `
            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    // Trigger the file download asynchronously
    setTimeout(() => {
        fetch(url, { method: 'GET' })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch the file');
                }
                return response.blob();
            })
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);  // Clean up the blob URL

                loadingNotification.close();
                Notification({
                    message: `
                            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                                <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Successful
                            </p>
                            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                                Your file "${fileName}" has been downloaded successfully.
                            </p>
                        `,
                    duration: 3000,
                    dangerouslyUseHTMLString: true,
                });
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
                loadingNotification.close();
                Notification({
                    message: `
                            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                                <i class="el-icon-error" style="margin-right: 10px; color: red;"></i> Download Error
                            </p>
                            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                                There was an error downloading file
                            </p>
                        `,
                    duration: 3000,
                    dangerouslyUseHTMLString: true,
                });
            });
    }, 0);
}

function downloadFileInBackgroundPdf(url, fileName) {
    const loadingNotification = Notification({
        message: `
            <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    setTimeout(() => {
        const link = document.createElement('a');
        link.href = url;

        // Kalau user kasih fileName, baru kita set.
        // Kalau tidak, biarkan kosong agar browser pakai nama asli.
        if (fileName) {
            link.setAttribute('download', fileName);
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        loadingNotification.close();
        Notification({
            message: `
                <p style="color: rgb(0, 0, 0); font-size: 20px; font-weight: bold;">
                    <i class="el-icon-success" style="margin-right: 10px; color: green;"></i> Download Started
                </p>
                <p style="color: rgb(0, 0, 0); font-size: 14px; margin-top: 10px;">
                    Your file is being downloaded.
                </p>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true,
        });
    }, 0);
}

async function downloadMediaBackground(url, fileName = 'downloaded-file') {
    const loadingNotification = Notification({
        message: `
            <p style="color: #000; font-size: 20px; font-weight: bold;">
                <i class="el-icon-loading" style="margin-right: 10px;"></i> Preparing your file...
            </p>
            <p style="color: #000; font-size: 14px; margin-top: 10px;">
                Please wait while we prepare your file for download.
            </p>
        `,
        duration: 0,
        dangerouslyUseHTMLString: true,
    });

    try {
        const response = await fetch(url, {
            method: 'GET'
        });

        if (!response.ok) throw new Error('Failed to fetch the file');

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);

        loadingNotification.close();
        Notification({
            message: `
                <div style="display: flex; align-items: center; gap: 10px; color: #2ecc71;">
                    <i class="el-icon-circle-check" style="font-size: 18px;"></i>
                    <span style="font-size: 15px;">Download Successful: "${fileName}"</span>
                </div>
            `,
            duration: 2500,
            dangerouslyUseHTMLString: true,
        });

    } catch (error) {
        console.error('Error downloading the file:', error);
        loadingNotification.close();
        Notification({
            message: `
                <div style="display: flex; align-items: center; gap: 10px; color: #e74c3c;">
                    <i class="el-icon-circle-close" style="font-size: 18px;"></i>
                    <span style="font-size: 15px;">Download Failed</span>
                </div>
            `,
            duration: 3000,
            dangerouslyUseHTMLString: true,
        });
    }
}

export { downloadFileInBackground, downloadFileInBackgroundPdf, downloadMediaBackground }